import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Versanddienstleister')
    .setRoute('shipment_carrier_settings_list')
    .setAdditionalRoutes(['shipment_carrier_settings_detail']);
